import { AlertBox, Icon } from '@iwoca/orion';
import styles from '../InformationBanners.module.css';
import { FormattedMessage } from 'react-intl';
import messages from './HomeScreenBanner.messages';
import { tracking } from '@iwoca/frontend-tracking-library';

const IOS_GUIDE_URL =
    'https://support.apple.com/en-gb/guide/iphone/iph42ab2f3a7/ios';
const ANDROID_GUIDE_URL =
    'https://support.google.com/chrome_webstore/answer/3060053?hl=en-GB';

export const HomeScreenBanner = () => {
    return (
        <div role="banner">
            <AlertBox className={styles.banner} variant="cancel">
                <div className={styles.bannerIcon}>
                    <Icon icon="infoCircleOutline" />
                </div>

                <div className={styles.content}>
                    <p>
                        <FormattedMessage {...messages.description} />
                    </p>
                    <p>
                        <FormattedMessage
                            {...messages.linksDescription}
                            values={{
                                iOSLink: (
                                    <a
                                        href={IOS_GUIDE_URL}
                                        target="_.blank"
                                        referrerPolicy="no-referrer"
                                        onClick={() => {
                                            tracking.ampli.homescreenBannerLinkClicked(
                                                { 'Link type': 'iOS' }
                                            );
                                        }}
                                    >
                                        <FormattedMessage
                                            {...messages.linkText}
                                        />
                                    </a>
                                ),
                                androidLink: (
                                    <a
                                        href={ANDROID_GUIDE_URL}
                                        target="_.blank"
                                        referrerPolicy="no-referrer"
                                        onClick={() => {
                                            tracking.ampli.homescreenBannerLinkClicked(
                                                { 'Link type': 'Android' }
                                            );
                                        }}
                                    >
                                        <FormattedMessage
                                            {...messages.linkText}
                                        />
                                    </a>
                                )
                            }}
                        />
                    </p>
                </div>
            </AlertBox>
        </div>
    );
};
